<template>
  <v-card
    :max-width="maxWidth"
    class="mx-auto overflow-hidden"
  >
    <v-row>
      <v-col
        class="d-flex"
        cols="6"
      >
        <v-img
          role="img"
          src="https://gm.goz.fun/wp-content/uploads/2023/03/review1.jpg"
          alt="Review Image 1"
        />
      </v-col>
      <v-col cols="6">
        <v-container
          class="pa-0 pl-2"
          style="margin: -4px 0"
        >
          <v-row>
            <v-col
              class="d-flex"
              cols="7"
            >
              <v-img
                role="img"
                src="https://gm.goz.fun/wp-content/uploads/2023/03/review2.png"
                alt="Review Image 2"
              />
            </v-col>
            <v-col
              class="d-flex"
              cols="5"
            >
              <v-img
                role="img"
                src="https://gm.goz.fun/wp-content/uploads/2023/03/review3.png"
                alt="Review Image 3"
              />
            </v-col>
            <v-col
              class="d-flex"
              cols="5"
            >
              <v-img
                role="img"
                src="https://gm.goz.fun/wp-content/uploads/2023/03/review4.png"
                alt="Review Image 4"
              />
            </v-col>
            <v-col
              class="d-flex"
              cols="7"
            >
              <v-img
                role="img"
                src="https://gm.goz.fun/wp-content/uploads/2023/03/review5.png"
                alt="Review Image 5"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <v-card-title class="align-start">
      <div>
        <span class="text-h5">{{ $t('components.reviews.title') }}</span>
        <div class="grey--text font-weight-light">
          {{ $t('components.reviews.category') }}
        </div>
      </div>
      <v-spacer />

      <v-dialog
        v-model="dialog"
        width="400"
        role="dialog"
        aria-labelledby="shareDialogTitle"
      >
        <template #activator="{ on }">
          <v-icon
            role="button"
            tabindex="0"
            aria-label="Share Review"
            @keydown.enter="$event.target.click()"
            @keydown.space.prevent="$event.target.click()"
            v-on="on"
          >
            mdi-share-variant
          </v-icon>
        </template>

        <v-card>
          <v-card-title>
            <span
              id="shareDialogTitle"
              class="text-h6 font-weight-bold"
            >
              {{ $t('components.reviews.buttons.share') }}
            </span>
            <v-spacer />
            <v-btn
              class="mx-0"
              icon
              aria-label="Close Share Dialog"
              @click="dialog = false"
            >
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-card-title>

          <v-list>
            <v-list-item
              :aria-label="$t('components.reviews.copy.shareFb')"
              role="link"
              tabindex="0"
              rel="noopener noreferrer"
              target="_blank"
              class="fb-xfbml-parse-ignore"
              :href="`https://www.facebook.com/sharer/sharer.php?u=${websiteLink}&src=sdkpreparse`"
            >
              <v-list-item-action>
                <v-icon>fab fa-facebook</v-icon>
              </v-list-item-action>
              <v-card-title>
                {{ $t('components.reviews.buttons.facebook') }}
              </v-card-title>
            </v-list-item>

            <v-list-item
              :aria-label="$t('components.reviews.copy.shareTwitter')"
              role="link"
              tabindex="0"
              rel="noopener noreferrer"
              target="_blank"
              class="twitter-share-button"
              :href="`https://twitter.com/intent/tweet?url=${websiteLink}`"
            >
              <v-list-item-action>
                <v-icon color="cyan">
                  fab fa-twitter
                </v-icon>
              </v-list-item-action>
              <v-card-title>
                {{ $t('components.reviews.buttons.twitter') }}
              </v-card-title>
            </v-list-item>
          </v-list>

          <v-text-field
            ref="link"
            :label="$t('components.reviews.copy.shareTitle')"
            class="pa-4"
            readonly
            :value="websiteLink"
            aria-describedby="shareInstructions"
            @click="sharableLink(websiteLink)"
          />
          <span
            id="shareInstructions"
            class="sr-only"
          >
            Click to copy the sharable link to clipboard
          </span>
        </v-card>
      </v-dialog>
    </v-card-title>

    <v-divider />

    <v-card-actions>
      <span class="pl-2 white--text text--darken-2 font-weight-light text-caption">
        {{ $t('components.reviews.totalReviews') }}
      </span>
      <v-spacer />
      <span class="pl-2 white--text text--darken-2 font-weight-light text-caption">
        {{ $t('components.reviews.exciteUserToReview') }}
      </span>
    </v-card-actions>

    <v-divider dark />

    <v-card-actions
      class="pa-4"
      role="button"
      tabindex="0"
      aria-label="Rate Us"
      @click="onRateUs(`${fbPage}reviews`)"
      @keydown.enter="onRateUs(`${fbPage}reviews`)"
      @keydown.space.prevent="onRateUs(`${fbPage}reviews`)"
    >
      {{ $t('components.reviews.rate') }}
      <v-spacer />
      <span class="grey--text text--lighten-2 text-caption mr-2">
        ({{ rating }})
      </span>
      <v-rating
        v-model="rating"
        background-color="white"
        color="orange accent-4"
        dense
        half-increments
        readonly
        hover
        size="18"
        aria-hidden="true"
      />
    </v-card-actions>
  </v-card>
</template>


<script>
import links from '@/constants/links';
import actions from "@/store/actions";
import { copyToClipboard } from "@/utils/text.utils";

export default {
    name: "ReviewCard",
    data() {
        return {
            dialog: false,
            rating: 5,
            fbPage: links.communities.fbPage,
            websiteLink: links.communities.website,
        }
    },
    computed: {
      maxWidth() {
        if (this.$vuetify.breakpoint.mdAndDown) {
            return 'auto'
        }

        return 600;
      },
    },
    methods: {
      sharableLink(link) {
        copyToClipboard(link).then(() => {
            actions.updateNotifications([{
                message: this.$t("components.clipboard"),
                color: 'success',
                icon: 'clipboard',
                iconColor: 'white',
            }]);
        })
      },
      onRateUs(link) {
        // track event
        // this.$ga.event("reviews", "rates-us", link);
        // go to link
        window.open(link);
      },
    }
};
</script>

<style scoped>
/* Component-specific styles */
</style>
